import { classNames } from 'shared/lib/classNames/classNames'
import cls from './FriendsItem.module.scss'
import { useRef, useState } from 'react'
import {
    Text,
    TextAlign,
    TextColor,
    TextSize,
    TextWeight,
} from 'shared/ui/Text/Text'
import { LevelUpIcon, NextIcon } from 'shared/ui/Icon'
import { useNavigate } from 'react-router-dom'
import { animated } from '@react-spring/web'
import { ImageWithSkeleton } from 'shared/ui/ImageWithSkeleton'

const DUPLICATE_TOUCH_CLICK_WINDOW_MS = 700
const TAP_MOVE_THRESHOLD_PX = 10

export const FriendsItem = (props) => {
    const {
        id,
        style,
        avatar,
        name,
        nickname,
        createdCount = 0,
        createdCountUpdated = false,
        onOpen,
    } = props

    const navigate = useNavigate()
    const lastTouchNavigationRef = useRef(0)
    const touchGestureRef = useRef(null)

    const [active, setActive] = useState(false)

    const onPointerDown = (event) => {
        setActive(true)

        if (event.pointerType === 'touch') {
            touchGestureRef.current = {
                pointerId: event.pointerId,
                startX: event.clientX,
                startY: event.clientY,
                moved: false,
            }
        }
    }

    const onPointerMove = (event) => {
        const gesture = touchGestureRef.current
        if (
            event.pointerType !== 'touch' ||
            !gesture ||
            gesture.pointerId !== event.pointerId ||
            gesture.moved
        ) {
            return
        }

        const movedX = Math.abs(event.clientX - gesture.startX)
        const movedY = Math.abs(event.clientY - gesture.startY)
        if (movedX > TAP_MOVE_THRESHOLD_PX || movedY > TAP_MOVE_THRESHOLD_PX) {
            gesture.moved = true
            setActive(false)
        }
    }

    const navigateToProfile = () => {
        onOpen?.()
        if (nickname) {
            navigate(`/${nickname}`)
        } else if (id !== undefined && id !== null) {
            navigate(`/${id}`)
        }
    }

    const onPointerUp = (event) => {
        setActive(false)
        if (event.pointerType !== 'touch') return

        event.preventDefault()
        lastTouchNavigationRef.current = Date.now()
        const gesture = touchGestureRef.current
        touchGestureRef.current = null

        if (
            gesture &&
            gesture.pointerId === event.pointerId &&
            !gesture.moved
        ) {
            navigateToProfile()
        }
    }

    const onPointerCancel = (event) => {
        setActive(false)
        if (event.pointerType === 'touch') {
            lastTouchNavigationRef.current = Date.now()
            touchGestureRef.current = null
        }
    }

    const onClick = (event) => {
        if (
            Date.now() - lastTouchNavigationRef.current <
            DUPLICATE_TOUCH_CLICK_WINDOW_MS
        ) {
            event.preventDefault()
            return
        }

        navigateToProfile()
    }

    return (
        <animated.button
            type="button"
            aria-label={`Открыть профиль ${name || nickname || id}`}
            className={classNames(cls.FriendsItem, {}, [])}
            onClick={onClick}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
            onPointerCancel={onPointerCancel}
            style={
                active
                    ? {
                          ...style,
                          transition: 'all 0.05s linear',
                          transform: 'translate3d(3px,3px,0)',
                          boxShadow: '0px 0px',
                      }
                    : style
            }
        >
            <span className={cls.avatarContainer}>
                <ImageWithSkeleton
                    src={avatar}
                    alt="avatar"
                    className={cls.avatar}
                />
                <span
                    className={cls.createdBadge}
                    aria-label={`Создано мечт: ${createdCount}`}
                >
                    {createdCountUpdated ? (
                        <LevelUpIcon className={cls.createdIcon} />
                    ) : null}
                    <span>{createdCount}</span>
                </span>
            </span>
            <div className={cls.nameContainer}>
                <Text
                    className={cls.name}
                    weight={TextWeight.SBOLD}
                    align={TextAlign.LEFT}
                >
                    {name || 'Мечтатель'}
                </Text>
                <Text
                    size={TextSize.S}
                    color={TextColor.TERBLACK}
                    align={TextAlign.LEFT}
                >
                    {nickname ? `@${nickname}` : `@${id}`}
                </Text>
            </div>
            <span className={cls.chevronContainer} aria-hidden="true">
                <NextIcon className={cls.chevron} />
            </span>
            <span className={cls.divider} aria-hidden="true" />
        </animated.button>
    )
}
